import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import {LoginRepository} from './repositories/login.repository';
import {LoginService} from './services/login.service';

import {LoginPage} from './components/login-page/login-page';
import { ModePage } from './components/mode-page/mode-page';
import { ModeInfoPage } from './components/mode-info-page/mode-info-page';


@NgModule({
  declarations: [
    LoginPage,
    ModePage,
    ModeInfoPage
  ],
  // entryComponents: [
  //   LoginPage,
  // ],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    RouterModule.forChild([
      { path: '', component: LoginPage },
      { path: 'mode', component: ModePage },
      { path: 'mode-info/:mode', component: ModeInfoPage },
    ]),
  ],
  providers: [
    LoginService,
    LoginRepository,
  ],
})
export class LoginModule { }
